import { jsx as _jsx } from "react/jsx-runtime";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { ContentWithImageSection } from "../content-with-image-section";
import styles from "./how-stores-work.module.css";
export const HowStoresWork = ({ howStoresWork  })=>/*#__PURE__*/ _jsx("section", {
        className: styles.howStoresWork,
        children: howStoresWork.map((section)=>/*#__PURE__*/ _jsx(ContentWithImageSection, {
                title: section.title,
                body: renderWithResolver(section.body),
                image: section.image
            }, section.title))
    });
